import type { ICartItemDetail } from '@/common/interfaces/cart.interface';

export const needsStoreCheckoutProductTitleEnrichment = (item: ICartItemDetail): boolean => {
  const hasTitle = Boolean(item.productTitle?.trim() || item.apparelName?.trim());

  return !hasTitle;
};

export const applyApparelCatalogNameToCartItem = (
  item: ICartItemDetail,
  catalogName: string
): ICartItemDetail => {
  const name = catalogName.trim();

  if (!name || !needsStoreCheckoutProductTitleEnrichment(item)) {
    return item;
  }

  return {
    ...item,
    apparelName: name,
    productTitle: name,
  };
};

export const applyApparelCatalogNamesToCartItems = (
  items: ICartItemDetail[],
  nameByItemId: Record<number, string>
): ICartItemDetail[] => {
  let hasChanges = false;

  const nextItems = items.map((item) => {
    const catalogName = nameByItemId[item.id];

    if (!catalogName) {
      return item;
    }

    const nextItem = applyApparelCatalogNameToCartItem(item, catalogName);

    if (nextItem !== item) {
      hasChanges = true;
    }

    return nextItem;
  });

  return hasChanges ? nextItems : items;
};

/** C1717 → also try 1717 when catalog lookups are keyed by numeric style only. */
export const resolveProductSelectionsStyleCodeCandidates = (styleCode: string): string[] => {
  const trimmed = styleCode.trim();

  if (!trimmed) {
    return [];
  }

  const candidates = [trimmed];

  if (/^[A-Za-z]\d+$/.test(trimmed)) {
    candidates.push(trimmed.slice(1));
  }

  return [...new Set(candidates)];
};
